<template>
  <div>
    <div v-for="([key, value], index) in Object.entries(data)" :key="index + key">
      <div v-if="ifGroupField(key)" :class="$style.rowContainer" :style="indent(padding, true)" @click="toggle(value)">
        <div :class="[$style.expandButton, {[$style.expanded]: value.expanded}]" />

        <div v-if="columns[depth].field === 'details'" v-html="key" />
        <div v-else>
          <div v-if="columns[depth].field === 'messenger'">
            <img :src="getMessengerIcon(key)" :class="$style.messengerIcon">
            <span :class="$style.messengerName">{{ key }}</span>
          </div>
          <div v-else-if="columns[depth].field === 'direction'">
            <img :src="getMessageDirectionIcon(key)" :class="$style.directionIcon">
            <span :class="$style.directionName">{{ key }}</span>
          </div>
          <div v-else>
            {{ key }}
          </div>
        </div>
      </div>
      <div v-show="value.expanded">
        <div v-if="!value.array || !Array.isArray(value.array)">
          <grouped-table-view
            :data="value"
            :columns="columns"
            :depth="depth + 1"
            :padding="padding + columns[depth].widthNum"
            :selected-row="selectedRow"
            @changeSelectedRow="(row) => $emit('changeSelectedRow', row)"
          />
        </div>
        <div v-if="value.array && Array.isArray(value.array)" :style="indent(padding + columns[depth].widthNum)">
          <div
            v-for="(row, index) in value.array"
            :key="row.id.toString() + index.toString()"
            :class="[
              {[$style.active]: selectedRow && row.id === selectedRow},
              {[$style.red]: !row.checkUser},
              $style.row,
            ]"
            @click="$emit('changeSelectedRow', row)"
          >
            <div
              v-for="column in columns.slice(depth + 1)"
              :key="column.field"
              :style="{
                width: getWidth(column.widthNum),
                overflowWrap: 'break-word',
                wordBreak: 'break-all',
                padding: '0px 5px',
              }"
            >
              <img
                v-if="column.field === 'path' && row.exists === 1"
                src="@/assets/images/icons/navigation/confirm.svg"
                :class="$style.icon"
              >
              <img
                v-if="column.field === 'path' && row.exists === 0"
                src="@/assets/images/icons/navigation/cancel.svg"
                :class="$style.icon"
              >

              <div v-if="column.field === 'details'">
                <log-details :data="row" />
              </div>
              <div v-else>
                <div v-if="column.field === 'messenger'">
                  <img :src="getMessengerIcon(row.messenger)" :class="$style.messengerIcon">
                  <span :class="$style.messengerName">{{ row.messenger }}</span>
                </div>
                <div v-else-if="column.field === 'interlocutor'">
                  <span :class="$style.dangerous">
                    <dangerous :value="row.statusDangerous" />
                  </span>
                  <span v-if="row.customNickname"> {{ row.customNickname }} ({{ row.interlocutor }}) </span>
                  <span v-else>
                    {{ row.interlocutor }}
                  </span>
                </div>
                <div v-else-if="column.field === 'direction'">
                  <img :src="getMessageDirectionIcon(row.direction)" :class="$style.directionIcon">
                  <span :class="$style.directionName">{{ row.direction }}</span>
                </div>
                <div v-else-if="column.field === 'text'">
                  <column-text :row="row" :record-id="row.id" />
                </div>
                <div v-else>
                  {{ row[column.field] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessengerIcon } from '@/helpers/messengers';
import IconMessageDirectionInbox from '@/assets/images/icons/message-direction/inbox.svg';
import IconMessageDirectionOutbox from '@/assets/images/icons/message-direction/outbox.svg';

import Dangerous from '@/components/common/dangerous/index.vue';
import ColumnText from '@/components/pages/computers/log/messengers/components-default/column-text.vue';

export default {
  name: 'GroupedTableView',
  components: {
    Dangerous,
    ColumnText,
  },

  props: ['data', 'columns', 'depth', 'padding', 'selectedRow'],
  data: () => ({}),
  methods: {
    getWidth(width) {
      const max = 100 - (this.padding + this.columns[this.depth].widthNum + 10 * (this.depth + 1));
      const resultWidth = (width * 100) / max;
      return `${resultWidth}%`;
    },
    ifGroupField(key) {
      if (key !== 'expanded' && typeof this.data[key] !== 'boolean') {
        return true;
      }
      return false;
    },
    toggle(value) {
      this.$set(value, 'expanded', !value.expanded);
    },
    indent(padding, top) {
      if (top) {
        if (padding === 0) {
          return {
            marginLeft: '5px',
            top: `${80 + 30 * this.depth}px`,
            zIndex: `${this.columns.length + 1 - this.depth}`,
          };
        }

        return {
          marginLeft: `${padding + this.depth}%`,
          top: `${80 + 30 * this.depth}px`,
          zIndex: `${this.columns.length + 1 - this.depth}`,
        };
      }
      return {
        paddingLeft: `${padding + this.depth}%`,
      };
    },
    getMessengerIcon(name) {
      return getMessengerIcon(name);
    },
    getMessageDirectionIcon(direction) {
      switch (direction) {
        case this.$t('pages.directionNameDict.incoming'):
          return IconMessageDirectionInbox;
        case this.$t('pages.directionNameDict.outgoing'):
          return IconMessageDirectionOutbox;
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss" module>
  .directionIcon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }
  .directionName {
    vertical-align: middle;
  }
  .dangerous {
    display: inline-block;
    margin-right: 8px;
  }
  .messengerIcon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }
  .messengerName {
    vertical-align: middle;
  }
  .expandButton {
    flex-shrink: 0;
    margin-left: 5px;
    margin-right: 13px;
    width: 14px;
    height: 14px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: 1px solid $branchColor;
    background: $white;
    z-index: 2;

    &::before,
    &::after {
      content: '';
      background-color: $blue;
      width: 8px;
      height: 2px;
      position: absolute;
      transition: 0.25s ease-out;
    }

    &::before {
      transform: rotate(90deg);
    }

    &::after {
      transform: rotate(180deg);
    }

    &.expanded {
      &::before {
        transform: rotate(0);
      }

      &::after {
        transform: rotate(0);
      }
    }
  }
  .rowContainer {
    display: flex;
    cursor: pointer;
    border: 1px solid #dfdfdf;
    word-break: break-all;
    padding: 5px;
    font-size: 13px;
    align-content: center;
    margin: 5px;
    top: 80px;
    background: white;
  }
  .row {
    display: flex;
    padding: 10px;
    font-size: 13px;
    cursor: pointer;
    &:hover {
      background: $light-gray;
    }
    &.active {
      background: $light-gray;
    }
  }
  .icon {
    display: inline-flex;
    margin-right: 10px;
    width: 15px;
  }
</style>
